import { makeStyles } from "@mui/styles";
import ReCAPTCHA from "react-google-recaptcha";
import { SITE_KEY_CAPTCHA_GOOGLE } from "src/const/const-from-env";
import React, { useRef } from "react";
const useStyles = makeStyles((theme) => {
  return {
    textError: {
      fontSize: "12px",
      color: "#FF0101",
      marginTop: "10px",
      lineHeight: "13px",
      maxWidth: "304px",
    },
    containerRecaptcha: {
      display: "flex",
      justifyContent: "center",
    },
  };
});
//! Type
interface PropsI {
  checkValueRecapcha?: (token: string) => void;
  isValueCaptcha?: boolean | any;
  firtsView?: boolean;
  ref:any
}
// const key = "6LdqheYkAAAAACC2GrbUnhcwJVTu4cJuQ9AlQP0b";
const RecaptchaGoogle = (props:PropsI,ref) => {
  const {checkValueRecapcha,isValueCaptcha,firtsView} = props
  const classes = useStyles();
  
  return (
    <div className={classes.containerRecaptcha}>
      <div className="">
        <ReCAPTCHA
          ref={ref}
          sitekey={SITE_KEY_CAPTCHA_GOOGLE}
          hl="vi"
          type="image"
          theme="light"
          onErrored={(e) => {}}
          onExpired={() => {
            checkValueRecapcha("");
          }}
          onChange={(token) => {
            checkValueRecapcha(token);
          }}
        />
        {isValueCaptcha && firtsView && (
          <div className={classes.textError}>Vui lòng xác nhận captcha</div>
        )}
      </div>
    </div>
  );
};

export default React.forwardRef(RecaptchaGoogle);
